export default "__VITE_ASSET__BXPAverQ__"